
import { Hooks } from 'interface/sharedJsInterface.js';

const {
  B2b,
  ClinicalPearls,
  Categories,
  Cme,
  Loading,
  Performance,
  QuestionsFilter,
  RiskAssessment,
  StaticData,
  Subjects,
  TakingQuiz,
  Users,
  BoardExamDates,
  Lti,
  Organizations,
  Params,
  Products,
  Quiz,
  React,
  Subscriptions,
} = Hooks;

export {
  B2b,
  ClinicalPearls,
  Categories,
  Cme,
  Loading,
  Performance,
  QuestionsFilter,
  RiskAssessment,
  StaticData,
  Subjects,
  TakingQuiz,
  Users,
  BoardExamDates,
  Lti,
  Organizations,
  Params,
  Products,
  Quiz,
  React,
  Subscriptions,
};
